// extracted by mini-css-extract-plugin
export default {"brand":"Logo_brand__Q-ZI0","brandIcon":"Logo_brandIcon__ofVdw","brandText":"Logo_brandText__Y+caU"};